import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-back-link',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './back-link.component.html',
  styleUrls: ['./back-link.component.scss']
})
export class BackLinkComponent {
  @Input() link!: any[] | string;
  @Input() label: string = 'Back';
}
